module.exports = __webpack_public_path__ + "img/esg-rz-pdf.9421b1b5.png";